import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-22a7a15a"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "media-config-wrapper"
};
var _hoisted_2 = {
  class: "media-config"
};
var _hoisted_3 = {
  class: "config-list"
};
var _hoisted_4 = {
  class: "item"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "title"
  }, "音视频配置：", -1);
});
var _hoisted_6 = {
  class: "value"
};
var _hoisted_7 = {
  class: "setting-list"
};
var _hoisted_8 = {
  class: "check-box"
};
var _hoisted_9 = {
  class: "video-box"
};
var _hoisted_10 = {
  class: "operate-box"
};
var _hoisted_11 = /*#__PURE__*/_createTextVNode(" 开始检测 ");
var _hoisted_12 = /*#__PURE__*/_createTextVNode("停止检测");
import { reactive, ref, onUnmounted, computed, nextTick } from 'vue';
import { getMediaConfig, setMediaConfig, clearLocalMediaConfig } from '@/utils/device/mediaConfig';
import JsonEditorVue from 'json-editor-vue';
import { SettingOutlined, ClearOutlined, SettingFilled } from '@ant-design/icons-vue';
import { logger } from '@/utils';
import moment from 'moment';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var config = ref(getMediaConfig());
    var visible = ref(false);
    var videoRef = ref(null);
    var streamRef = ref(null);
    var settingList = ref([{
      name: '默认设置一（新版）',
      config: {
        audio: true,
        video: {
          width: {
            ideal: 640,
            max: 640
          },
          height: {
            ideal: 480,
            max: 480
          },
          frameRate: 15
        }
      }
    }, {
      name: '默认设置二（通用设置）',
      config: {
        audio: true,
        video: true
      }
    }, {
      name: '默认设置三（旧版）',
      config: {
        audio: true,
        video: {
          width: {
            min: 640,
            ideal: 640,
            max: 640
          },
          height: {
            min: 480,
            ideal: 480,
            max: 480
          },
          framerate: 60
        }
      }
    }]);
    var formState = reactive({
      txt: ''
    });
    var hasMediaStream = computed(function () {
      return !!streamRef.value;
    });
    function getConfirmModal(ev) {
      ev.preventDefault();
      visible.value = true;
      return;
    }
    function clearConfig(ev) {
      ev.preventDefault();
      clearLocalMediaConfig();
      window.location.reload();
    }
    function setConfig(itemConfig) {
      config.value = itemConfig;
      setMediaConfig(itemConfig);
    }
    function getConfig() {
      var configData = null;
      if (typeof config.value === 'string') {
        configData = JSON.parse(config.value);
      } else {
        configData = config.value;
      }
      return configData;
    }
    function confirmConfigModal() {
      // 临时密码 技术人员专业调试时使用
      var pwd = window.btoa(moment().format('YYYY-MM-DD'));
      var inputPwd = window.btoa(formState.txt);
      if (inputPwd !== pwd) {
        _message.error('密码错误');
        return;
      }
      var configData = getConfig();
      logger.info(configData, '__setMediaConfig');
      setMediaConfig(configData);
      formState.txt = '';
      visible.value = false;
    }
    var startCheck = function () {
      var configData = getConfig();
      logger.info(configData, '__startCheck');
      stopCheck();
      navigator.mediaDevices.getUserMedia(configData).then(function (mstream) {
        var videoEl = videoRef.value;
        streamRef.value = mstream;
        if (videoEl) {
          videoEl.srcObject = mstream;
        }
        mstream.getTracks().forEach(function (track) {
          track.onended = function () {
            track.stop();
          };
        });
      }).catch(function (e) {
        logger.error(e, '__getUserMedia');
      });
    };
    var stopCheck = function () {
      var stream = streamRef.value;
      if (stream) {
        stream.getTracks().forEach(function (track) {
          track.stop();
        });
        nextTick(function () {
          streamRef.value = null;
        });
      }
    };
    onUnmounted(function () {
      stopCheck();
    });
    return function (_ctx, _cache) {
      var _component_a_tag = _resolveComponent("a-tag");
      var _component_a_card = _resolveComponent("a-card");
      var _component_a_button = _resolveComponent("a-button");
      var _component_a_input_password = _resolveComponent("a-input-password");
      var _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_card, {
        title: "媒体检测本地配置",
        class: "mb20"
      }, {
        extra: _withCtx(function () {
          return [_createElementVNode("a", {
            href: "javascript:void(0)",
            class: "mr1",
            onClick: clearConfig
          }, [_createVNode(_unref(ClearOutlined))]), _createElementVNode("a", {
            href: "javascript:void(0)",
            onClick: getConfirmModal
          }, [_createVNode(_unref(SettingOutlined))])];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(_unref(JsonEditorVue), {
            modelValue: config.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return config.value = $event;
            }),
            mode: "text",
            theme: "dark",
            "main-menu-bar": false
          }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(settingList.value, function (item) {
            return _openBlock(), _createBlock(_component_a_tag, {
              class: "setting-tag",
              key: item.name,
              onClick: function ($event) {
                return setConfig(item.config);
              },
              color: "#FF6A00"
            }, {
              icon: _withCtx(function () {
                return [_createVNode(_unref(SettingFilled))];
              }),
              default: _withCtx(function () {
                return [_createTextVNode(" " + _toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["onClick"]);
          }), 128))])])])];
        }),
        _: 1
      }), _createVNode(_component_a_card, {
        title: "媒体检测"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("video", {
            class: "video",
            ref: function (_value, _refs) {
              _refs['videoRef'] = _value;
              videoRef.value = _value;
            },
            autoplay: ""
          }, null, 512)]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_a_button, {
            type: "primary",
            onClick: startCheck,
            disabled: _unref(hasMediaStream),
            class: "mr10"
          }, {
            default: _withCtx(function () {
              return [_hoisted_11];
            }),
            _: 1
          }, 8, ["disabled"]), _createVNode(_component_a_button, {
            type: "primary",
            onClick: stopCheck
          }, {
            default: _withCtx(function () {
              return [_hoisted_12];
            }),
            _: 1
          })])])];
        }),
        _: 1
      }), _createVNode(_component_a_modal, {
        visible: visible.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = function ($event) {
          return visible.value = $event;
        }),
        title: "确认配置",
        "ok-text": "确认",
        "cancel-text": "取消",
        onOk: confirmConfigModal
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_input_password, {
            value: _unref(formState).txt,
            "onUpdate:value": _cache[1] || (_cache[1] = function ($event) {
              return _unref(formState).txt = $event;
            })
          }, null, 8, ["value"])];
        }),
        _: 1
      }, 8, ["visible"])]);
    };
  }
});